/**
 * Where a test detail body's CTAs say they are, in the `cta_click` event
 * (`track.ctaClick(label, location, href)`). The test route uses the
 * defaults below. The blood ad pages under `/go/bloodtest` render the same
 * body and pass their own, so their clicks stay theirs, see
 * `bloodGoTracking` in `membership-first/blood-go-page.tsx`.
 */
export type TestDetailTracking = {
  /**
   * The base location. Section CTAs add their section to it, `-ella` and
   * `-steps`, and the hero adds `-hero-mobile` or `-hero-desktop` unless
   * `hero` is set.
   */
  location: string
  /**
   * The hero's booking button, phone and desktop alike, with this exact
   * label and location in place of the button's text and the base location.
   */
  hero?: { label: string; location: string }
  /** The plan block's `track`, which its CTAs build their labels from. */
  plan: string
  /** The insurance section's location. */
  insurance: string
  /** The single tests' "Book without the plan" link, when not its default. */
  singleTests?: string
  /** The closing block's booking button, when not its default. */
  close?: string
}

/** The test route's own tracking, `test-detail-<slug>` and so on. */
export function testDetailTracking(slug: string): TestDetailTracking {
  return {
    location: `test-detail-${slug}`,
    plan: `test-${slug}`,
    insurance: "test-detail-insurance",
  }
}
